import { InfertilityType } from '../../../models/ViewModels/RecordCatalogViewModel'
import { DatePicker, Select, TextBox } from '../../../share/Elements'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { RecordInfertilityType } from '../../../models/ViewModels/RecordViewModel'

const RecordInfertility = ({
  catalog,
  item,
  onItemChange,
}: {
  catalog?: InfertilityType
  item?: RecordInfertilityType
  onItemChange?: (updatedItem: RecordInfertilityType) => void // A function to handle item changes
}) => {
  const handleTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const updatedItem: RecordInfertilityType = {
      ...item,
      type: Number(event.target.value),
      hsgDate: item?.hsgDate === 0 ? 1 : item?.hsgDate,
      transferType: item?.transferType === 0 ? 1 : item?.transferType,
    }
    onItemChange && onItemChange(updatedItem)
  }
  const handleHsgDateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const updatedItem: RecordInfertilityType = {
      ...item,
      hsgDate: Number(event.target.value),
      type: item?.type === 0 ? 1 : item?.type,
      transferType: item?.transferType === 0 ? 1 : item?.transferType,
    }
    onItemChange && onItemChange(updatedItem)
  }

  // onIsAbstractChange(updateItem) // roadmap.sh |engineeering .dustav
  return (
    <>
      <div className='mr-3 mb-2'>
        <label className='text-secondary'>نمایش در پرونده</label>
        <input
          type='checkbox'
          className='m-1.5'
          checked={item?.isAbstract || false}
          onChange={() => {
            const updatedItem: RecordInfertilityType = {
              ...item,
              isAbstract: !item?.isAbstract,
              type: item?.type === 0 ? 1 : item?.type,
              hsgDate: item?.hsgDate === 0 ? 1 : item?.hsgDate,
              transferType: item?.transferType === 0 ? 1 : item?.transferType,
            }
            onItemChange && onItemChange(updatedItem)
          }}
        ></input>
      </div>
      <div className='p-5 grid md:grid-cols-8 sm:grid-cols-3 gap-5 '>
        {/* <select value={item?.type} onChange={handleTypeChange}>
            {catalog?.infertilityType?.map((type, key) => (
              <option key={key} value={type.id}>
                {type.title}
              </option>
            ))}
          </select> */}
        <Select value={item?.type} onChange={handleTypeChange}>
          {catalog?.infertilityType?.map((type, key) => (
            <option key={key} value={type.id}>
              {type.title}
            </option>
          ))}
        </Select>
        <div className=''>
          <TextBox
            debounceTime={0}
            Type={TextBoxTypeEnum.Text}
            isRequired={true}
            innerText='مرکز'
            value={item?.center?.toString()}
            onChange={(e) => {
              const updatedItem: RecordInfertilityType = {
                ...item,
                center: e.target.value,
                type: item?.type === 0 ? 1 : item?.type,
                hsgDate: item?.hsgDate === 0 ? 1 : item?.hsgDate,
                transferType: item?.transferType === 0 ? 1 : item?.transferType,
              }
              onItemChange && onItemChange(updatedItem)
            }}
          ></TextBox>
        </div>

        <TextBox
          innerText='سال'
          isRequired={true}
          debounceTime={0}
          Type='number'
          value={item?.year === 0 ? '' : item?.year?.toString()}
          onChange={(e) => {
            const updatedItem: RecordInfertilityType = {
              ...item,
              year: Number(e.target.value),
              type: item?.type === 0 ? 1 : item?.type,
              hsgDate: item?.hsgDate === 0 ? 1 : item?.hsgDate,
              transferType: item?.transferType === 0 ? 1 : item?.transferType,
            }
            onItemChange && onItemChange(updatedItem)
          }}
        />
        <TextBox
          debounceTime={0}
          innerText='چند تخمک'
          isRequired={true}
          Type='number'
          value={item?.ovulationCount?.toString()}
          onChange={(e) => {
            const updatedItem: RecordInfertilityType = {
              ...item,
              ovulationCount: Number(e.target.value),
              type: item?.type === 0 ? 1 : item?.type,
              hsgDate: item?.hsgDate === 0 ? 1 : item?.hsgDate,
              transferType: item?.transferType === 0 ? 1 : item?.transferType,
            }
            onItemChange && onItemChange(updatedItem)
          }}
        />
        <div className='text-sm flex justify-center items-center gap-2'>
          <label className='whitespace-nowrap'>تاریخ HSG: </label>
          <select value={item?.hsgDate} onChange={handleHsgDateChange}>
            {catalog?.infertilityHsqDate?.map((type, key) => (
              <option key={key} value={type.id}>
                {type.title}
              </option>
            ))}
          </select>
        </div>
        <div className='text-sm flex justify-center items-center gap-2'>
          <label htmlFor='' className='whitespace-nowrap'> انتقال: </label>
          <Select
            value={item?.transferType}
            onChange={(e) => {
              const updatedItem: RecordInfertilityType = {
                ...item,
                transferType: Number(e.target.value),
                type: item?.type === 0 ? 1 : item?.type,
                hsgDate: item?.hsgDate === 0 ? 1 : item?.hsgDate,
              }
              onItemChange && onItemChange(updatedItem)
            }}
          >
            {catalog?.infertilityTransferType?.map((type, key) => (
              <option key={key} value={type.id}>
                {type.title}
              </option>
            ))}
          </Select>
        </div>
        <div className='flex justify-center items-center gap-2'>
          <label className='whitespace-nowrap text-sm'>جنینی دارند/ندارند؟</label>
          <input
            type='checkbox'
            className='m-1.5'
            name='existEmbryo'
            checked={item?.existEmbryo || false}
            onChange={() => {
              const updatedItem: RecordInfertilityType = {
                ...item,
                existEmbryo: !item?.existEmbryo,
                type: item?.type === 0 ? 1 : item?.type,
                hsgDate: item?.hsgDate === 0 ? 1 : item?.hsgDate,
                transferType:
                  item?.transferType === 0 ? 1 : item?.transferType,
              }
              onItemChange && onItemChange(updatedItem)
            }}
          />
        </div>
        <DatePicker
          innerText='تاریخ'
          isRequired={false}
          className=''
          name='Date'
          raytebValue={item?.embryoDate}
          value={
            item?.embryoDate ? new Date(item?.embryoDate).toShamsi() : ''
          }
          onChange={(e) => {
            const updatedItem: RecordInfertilityType = {
              ...item,
              embryoDate: e.target.valueMiladi,
            }
            onItemChange && onItemChange(updatedItem)
          }}
        />
      </div>
    </>
  )
}

export default RecordInfertility
